import { DashboardInterface } from 'Interfaces/DashBoardInterface';

export const getLayout = (id: string, i: number, columns: number) => {
  return {
    i: `${id}`,
    x: (i % columns) * (12 / columns),
    y: Math.floor( i / columns) * columns,
    w: 12 / columns,
    h: 4,
    isResizable: false
  };
};

export const cleanLayouts = (dashboards: DashboardInterface[]) => {
  dashboards.forEach(d => {
    if (d.layout) {
      const invalid = d.layout.find(l => l.w < 3);
      if (invalid) {
        d.layout = d.layout.map((l, i) => getLayout(l.i, i, d.columns || 2));
      }
    }
  });
};
